import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgIdentityLawyer(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M95 32H24.98C22.23 32 20 34.17 20 36.84v46.55c0 2.67 2.23 4.84 4.98 4.84H95c2.75 0 4.98-2.17 4.98-4.84V36.84c0-2.67-2.23-4.84-4.98-4.84Z"
        fill="#F1F5F9"
      />
      <path
        d="M19.2 80.74V43a.8.8 0 1 1 1.6 0v37.74c0 3.466 2.9 6.31 6.52 6.31h58.03a.8.8 0 0 1 0 1.6H27.32c-4.459 0-8.12-3.516-8.12-7.91Z"
        fill="#0F172A"
      />
      <path
        d="M54 39H30a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h24a3 3 0 0 0 3-3V42a3 3 0 0 0-3-3Z"
        fill="#A6DBCB"
      />
      <path
        d="M33 61.28c0-4.69 3.91-8.49 8.74-8.49s8.73 3.8 8.73 8.5V67H33v-5.72ZM41.86 51.85c2.68 0 4.86-2.11 4.86-4.72s-2.18-4.72-4.86-4.72S37 44.52 37 47.13s2.18 4.72 4.86 4.72Z"
        fill="#007A5F"
      />
      <path d="M92.6 40a.8.8 0 0 1 0 1.6H61.95a.8.8 0 1 1 0-1.6H92.6Z" fill="#78B441" />
      <path
        d="M80.89 64.4a.8.8 0 0 1 0 1.6H61.95a.8.8 0 1 1 0-1.6h18.94ZM92.6 58.3a.8.8 0 0 1 0 1.6H61.95a.8.8 0 1 1 0-1.6H92.6ZM92.6 52.2a.8.8 0 0 1 0 1.6H61.95a.8.8 0 1 1 0-1.6H92.6ZM92.6 46.1a.8.8 0 0 1 0 1.6H61.95a.8.8 0 1 1 0-1.6H92.6Z"
        fill="#B3C0D0"
      />
      <path
        d="M92 70H29a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h63a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2Z"
        fill="#A6DBCB"
      />
      <path
        d="m35.85 78.5.12-2.11-1.82 1.16-.65-1.1 1.94-.95-1.94-.95.65-1.1 1.82 1.16-.12-2.11h1.3l-.12 2.11 1.82-1.16.65 1.1-1.95.95 1.95.95-.65 1.1-1.82-1.16.12 2.11h-1.3ZM47.85 78.5l.12-2.11-1.82 1.16-.65-1.1 1.94-.95-1.94-.95.65-1.1 1.82 1.16-.12-2.11h1.3l-.12 2.11 1.82-1.16.65 1.1-1.95.95 1.95.95-.65 1.1-1.82-1.16.12 2.11h-1.3ZM59.85 78.5l.12-2.11-1.82 1.16-.65-1.1 1.94-.95-1.94-.95.65-1.1 1.82 1.16-.12-2.11h1.3l-.12 2.11 1.82-1.16.65 1.1-1.95.95 1.95.95-.65 1.1-1.82-1.16.12 2.11h-1.3ZM71.85 78.5l.12-2.11-1.82 1.16-.65-1.1 1.94-.95-1.94-.95.65-1.1 1.82 1.16-.12-2.11h1.3l-.12 2.11 1.82-1.16.65 1.1-1.95.95 1.95.95-.65 1.1-1.82-1.16.12 2.11h-1.3ZM83.85 78.5l.12-2.11-1.82 1.16-.65-1.1 1.94-.95-1.94-.95.65-1.1 1.82 1.16-.12-2.11h1.3l-.12 2.11 1.82-1.16.65 1.1-1.95.95 1.95.95-.65 1.1-1.82-1.16.12 2.11h-1.3Z"
        fill="#00664F"
      />
    </svg>
  )
}
export default wrapIllustration(SvgIdentityLawyer)
